import { render } from "./ShareAlert.vue?vue&type=template&id=66bf59ed&scoped=true&ts=true"
import script from "./ShareAlert.vue?vue&type=script&lang=ts"
export * from "./ShareAlert.vue?vue&type=script&lang=ts"

import "./ShareAlert.vue?vue&type=style&index=0&id=66bf59ed&lang=sass&scoped=true"
/* custom blocks */
import block0 from "./ShareAlert.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bf59ed"]])

export default __exports__